'use client'

import { useSiteContext, useTranslations } from '@dustin-web/microsite-components/src/hooks'
import React from 'react'
import { getString } from './macro-parameter-extractor'
import { MacroProps } from './macro-props'
import { useAuth } from '@dustin-web/microsite-components/src/auth'

export const PricingRulePreRegistration = (props: MacroProps) => {
  const { siteUrl } = useSiteContext()

  const buttonText = getString('buttontext', props)
  const preRegistrationToken = getString('preregistrationtoken', props)
  const alternativeRoute = getString('alternativeroute', props)

  //authsite routes
  const route =
    alternativeRoute === 'joinbusinesscustomer' ? 'joinbusinesscustomer' : 'registration'

  const { translate } = useTranslations()
  const { isAuthenticated, isLoading } = useAuth()

  return (
    !isLoading &&
    !isAuthenticated && (
      <a
        href={`/${route}?return_url=${siteUrl}&preregistrationtoken=${encodeURIComponent(
          preRegistrationToken
        )}`}
        className="btn btn-primary btn-lg">
        {buttonText || translate('PricingRulePreRegistration_Register')}
      </a>
    )
  )
}

export default PricingRulePreRegistration
